module.exports = __webpack_public_path__ + "static/media/map-1.346e2450.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-1.png
// module id = 583
// module chunks = 23